import React from 'react';
import { SquarePen, X } from 'lucide-react';
import QuantityInput from '../../QuantityInput';
import Button from '../../Button';
import Price from '../../Price';
import './PackageProduct.css';

export default function PackageProduct({
  image,
  imageAlt = '',
  title,
  price,
  unitPrice,
  priceState = 'default',
  originalPrice = '',
  unitOriginalPrice,
  savingsText = '',
  priceSuffix = ',-',
  quantity,
  onQuantityChange,
  lockQuantity = false,
  onEdit,
  onRemove,
  includedProducts = [],
  includedTitle = 'INCLUDED PRODUCTS',
  className = '',
}) {
  const qtyProps = quantity !== undefined
    ? { value: quantity }
    : { defaultValue: 1 };

  const effectiveQty = quantity !== undefined ? quantity : 1;
  const displayPrice = unitPrice != null
    ? `${unitPrice * effectiveQty}${priceSuffix}`
    : price;
  const displayOriginalPrice = unitOriginalPrice != null
    ? `${unitOriginalPrice * effectiveQty}${priceSuffix}`
    : originalPrice;

  return (
    <div className={`sc-package-product${className ? ` ${className}` : ''}`}>
      {/* Main package info */}
      <div className="sc-package-product__header">
        <div className="sc-package-product__image">
          {image && (
            <img
              src={image}
              alt={imageAlt}
              className="sc-package-product__img"
            />
          )}
        </div>

        <div className="sc-package-product__details">
          <div className="sc-package-product__title-price">
            <p className="sc-package-product__title typo-h4">{title}</p>
            <Price
              type="regular"
              state={priceState}
              price={displayPrice}
              originalPrice={displayOriginalPrice}
              savingsText={savingsText}
            />
          </div>
        </div>

        <div className="sc-package-product__actions">
          <QuantityInput
            {...qtyProps}
            onChange={onQuantityChange}
            min={1}
            disabled={lockQuantity}
          />
          <div className="sc-package-product__edit-remove">
            {onEdit && (
              <Button
                size="secondary"
                variant="text"
                iconOnly
                iconLeft={<SquarePen size={20} />}
                onClick={onEdit}
              />
            )}
            {onRemove && (
              <Button
                size="secondary"
                variant="text-danger"
                iconOnly
                iconLeft={<X size={20} />}
                onClick={onRemove}
              />
            )}
          </div>
        </div>
      </div>

      {/* Included products section */}
      {includedProducts.length > 0 && (
        <div className="sc-package-product__included">
          <p className="sc-package-product__included-title typo-h5">
            {includedTitle}
          </p>
          <div className="sc-package-product__included-grid">
            {includedProducts.map((item, idx) => (
              <div
                key={`${item.title}-${idx}`}
                className="sc-package-product__included-item"
              >
                <div className="sc-package-product__included-thumb">
                  {item.image && (
                    <img
                      src={item.image}
                      alt={item.imageAlt || item.title || ''}
                      className="sc-package-product__included-thumb-img"
                    />
                  )}
                </div>
                <div className="sc-package-product__included-info">
                  <p className="sc-package-product__included-name typo-body">
                    {item.title}
                  </p>
                  {Array.isArray(item.subtitle)
                    ? item.subtitle.filter(Boolean).map((line, li) => (
                        <p key={li} className="sc-package-product__included-sub typo-body-sm">
                          {line}
                        </p>
                      ))
                    : item.subtitle && (
                      <p className="sc-package-product__included-sub typo-body-sm">
                        {item.subtitle}
                      </p>
                    )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
